export default __webpack_public_path__ + "static/media/Giving_Made_Easy.c9dcb860.jpg";